export const RNLongDescription = () => {
    return (
        <>
            <div className="pt-3 pb-2">
                <p className="d-flex justify-content-center text-primary text-justify special-elite-regular">
                    In 2024 I had the honour of joining a study by Portsmouth
                    University into gender bias in the music industry. I was
                    initially brought in to write a program to web-scrape data
                    from various music venues across the UK, but this soon
                    expanded. I was then tasked to produce a series of 30 second
                    tracks that had both male and female versions, and also
                    instrumental tracks, to gain data in a controlled study as
                    to participants’ preferences, perceptions, and opinions.
                </p>
                <p className="d-flex justify-content-center text-primary text-justify special-elite-regular">
                    To be able to tell really short stories in the space of 30
                    seconds was such a wonderfully fun challenge. The underlying
                    music is a combination of pre-existing beds, and my own
                    compositions and recordings. I then composed vocal lines
                    that were brought to life through Ace Studio vocal synthesis
                    software. It's important to note, the vocals are all
                    directly modelled and trained by real vocalists specifically
                    for Ace Studio. Once I'd written in the score for the vocal
                    melodies and inserted all the lyrics, Ace Studio would then
                    generate the vocal lines, putting in inflections and
                    expression where it thought it should. Fortunately, the
                    software allowed me to override any or all of those elements
                    and fully shape the voice whenever I needed to.
                </p>
                <p className="d-flex justify-content-center text-primary text-justify special-elite-regular">
                    The first two pages are tracks that have male and female
                    vocal versions; some were whittled down for the final
                    surveys to try and present the most balance. Survey
                    participants were asked questions, such as which version
                    they preferred and what they think the instrumental
                    performers looked like. Although the idea was later dropped,
                    the use of A.I.-generated music covers was mooted as part of
                    the study; I have included these as part of the visual
                    imagery. This process was generally a lesson in banging my
                    head against a brick wall. Whilst I could prompt art styles
                    such as fauvism successfully, it was insistent on generating
                    extra things like hands holding the cover and refused to
                    remove them. I'd have to start a new prompt session each
                    time this happened (a lot). For further information on each
                    track, click on the associated button next to the track. For
                    more information on the study, please see the About section
                    of the site. *Hitting the Right Note is a working title and
                    will be subject to change.
                </p>
            </div>
        </>
    );
};
